import React, { useState, useEffect } from 'react';

const ViewerDashboard: React.FC = () => (
  <div className="container pt-1 main-container-div">ViewerDashboard</div>
);

export default ViewerDashboard;
